import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { B02ieCustomerUserInfoPage } from '../b02ie-customer-user-info/b02ie-customer-user-info';
import { B02idCustomerUserAddPage } from '../b02id-customer-user-add/b02id-customer-user-add';
import { B02iCustomerManagementPage } from '../b02i-customer-management/b02i-customer-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B02icCustomerUserListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface userInfo{
  USER_ID: number;
  USER_NAME: string;
  BRANCH_ID: number;
  BRANCH_NAME: string;
  GRP_ID: number;
  GRP_NAME: string;
  CORP_ID: number;
  CORP_NAME: string;
  CORP_ACTIVE: string;  
}

@IonicPage()
@Component({
  selector: 'page-b02ic-customer-user-list',
  templateUrl: 'b02ic-customer-user-list.html',
})
export class B02icCustomerUserListPage {

  loading: any;
  Status: any;

  CORP_ID:any;

  userArr: userInfo[] = [];
  userItems: userInfo[] = [];

  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController,) {

    this.CORP_ID = this.navParams.get('paramID');    //corporate ID

    let tbl = ["USER"];
    let column = ["CORP_ID"];
    let value = [this.CORP_ID];
    
    let tblkey = ["CORP_ID", "GRP_ID"];
    let fktbl = ["CORPORATE", "USER_GRP"];
    let fkkey = ["CORP_ID", "GRP_ID"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      
      if (this.Status == "1"){
        let Records = result["Records"];
/*         this.userData.USER_ID = Records[0]["USER_ID"];
        this.userData.USER_NAME = Records[0]["USER_NAME"];
        this.userData.BRANCH_ID = Records[0]["BRANCH_ID"];
        this.userData.GRP_ID = Records[0]["GRP_ID"];
        this.userData.CORP_ID = Records[0]["CORP_ID"];
        this.userData.CORP_ACTIVE = Records[0]["CORP_ACTIVE"];
        this.corpData.CORP_NAME = Records[0]["CORP_NAME"];
        console.log(this.userData); */

        this.userArr = Records;
        this.userItems = this.userArr;
        console.log(this.userItems);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
        this.errorMessage = "Login Error. Please try again.";
        this.loading.dismiss();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02icCustomerUserListPage');
  }

  editUser(USER_ID){
    this.navCtrl.push(B02ieCustomerUserInfoPage, {paramId: USER_ID});
  }

  goToAddUser(CORP_ID){
    this.navCtrl.push(B02idCustomerUserAddPage, {paramCorpId: CORP_ID});
  }

  goTo(){
    this.navCtrl.setRoot(B02iCustomerManagementPage);
  }

  showLoader(){    
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();

  }
}



// WEBPACK FOOTER //
// ./src/pages/b02ic-customer-user-list/b02ic-customer-user-list.ts